import {createMuiTheme} from '@material-ui/core/styles';

// Rebranding 2026 · Mood Premium Ivory Cream
// Palette: antracite + soft oro + petrolio (terzo colore)
const defaultTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#C9A961',           // Soft Oro
      dark: '#8A6E2E',           // Gold 700
      light: '#F1E4C4',          // Gold 100
      contrastText: '#1F2125',   // Antracite
    },
    secondary: {
      main: '#3A6B8A',           // Petrolio (terzo colore)
      contrastText: '#FFFFFF',
    },
    avatar: '#C9A961',
    table: {head: '#FAFAF8'},
    text: {
      primary: '#1F2125',        // Antracite
      secondary: '#6B6862',      // Antracite 300
    },
    background: {
      default: '#FEFEFE',        // Warm white
      paper: '#FEFEFE',
    },

    success: {
      main: '#3B8B6A',
      light: '#E8F2EC',
    },

    info: {
      main: '#3A6B8A',           // Petrolio
    },

    warning: {
      main: '#C48A1E',
    },

    error: {
      main: '#B0463C',
    },
  },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: '32px',
      letterSpacing: '-0.01em',
    },
    h2: {
      fontWeight: 600,
      fontSize: '26px',
      letterSpacing: '-0.01em',
    },
    h3: {
      fontWeight: 600,
      fontSize: '20px',
    },
    h6: {
      fontWeight: 600,
      fontSize: '14px',
    },
  },
});

export default defaultTheme;
